module.exports = __webpack_public_path__ + "assets/d64b116d9748a075e37897a2f5a99137.mp3";